import * as React from 'react';
import { Card, CardContent, Container, Grid } from 'ui';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: theme.colors.bgDefault,
    padding: 0,
    width: '100%',
    zIndex: theme.zIndex.appBar,
  },
  bottomContainer: {
    bottom: 0,
    left: 0,
    right: 0,
    position: 'fixed',
    paddingBottom: 'env(safe-area-inset-bottom)',
  },
  innerContainer: {
    width: '100%',
    margin: '0 auto',
    maxWidth: theme.typography.pxToRem(1000),
  },
  spacerColumn: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'block',
    },
  },
  card: {
    borderColor: theme.colors.borderDefault,
    '&.MuiPaper-outlined': {
      borderBottom: 'none',
      borderLeft: 'none',
      borderRight: 'none',
    },
    '&.MuiPaper-rounded': {
      borderRadius: 0,
    },
    [theme.breakpoints.up('md')]: {
      borderTop: 'none',
      position: 'relative',
    },
  },
  cardContent: {
    '&:last-child': {
      paddingBottom: 16,
    },
    [theme.breakpoints.up('md')]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
}));

const BottomContainer: React.FunctionComponent = ({ children }) => {
  const classes = useStyles();
  return (
    <Container className={clsx(classes.container, classes.bottomContainer)}>
      <div className={classes.innerContainer}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={8}>
            <Card variant="outlined" className={classes.card}>
              <CardContent className={classes.cardContent}>{children}</CardContent>
            </Card>
          </Grid>
          <Grid className={classes.spacerColumn} item xs={12} md={4} aria-hidden="true" />
        </Grid>
      </div>
    </Container>
  );
};

export default BottomContainer;
